module.exports = __webpack_public_path__ + "img/cash-on-delivery.fb990232.png";